import { render, staticRenderFns } from "./palaispaPoints.vue?vue&type=template&id=54e56bee&scoped=true&"
import script from "./palaispaPoints.vue?vue&type=script&lang=js&"
export * from "./palaispaPoints.vue?vue&type=script&lang=js&"
import style0 from "./palaispaPoints.vue?vue&type=style&index=0&id=54e56bee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e56bee",
  null
  
)

export default component.exports